import { render } from "./SelectStagioni.vue?vue&type=template&id=3e787221"
import script from "./SelectStagioni.vue?vue&type=script&lang=js"
export * from "./SelectStagioni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__